module.exports = __webpack_public_path__ + "img/ep1-12.a796ba9f.jpg";